import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export class Live extends Component {
  static propTypes = {};

  render() {
    const projectList = [
      {
        url: "https://datavedam.com/assets/bitcoin.png",
        name: "HiringHippo",
      },
      {
        url: "https://datavedam.com/assets/bitcoin.png",
        name: "HiringHippo",
      },
      {
        url: "https://datavedam.com/assets/bitcoin.png",
        name: "HiringHippo",
      },
      {
        url: "https://datavedam.com/assets/bitcoin.png",
        name: "HiringHippo",
      },
      {
        url: "https://datavedam.com/assets/bitcoin.png",
        name: "HiringHippo",
      },
      {
        url: "https://datavedam.com/assets/bitcoin.png",
        name: "HiringHippo",
      },
      {
        url: "https://datavedam.com/assets/bitcoin.png",
        name: "HiringHippo",
      },
      {
        url: "https://datavedam.com/assets/bitcoin.png",
        name: "HiringHippo",
      },
    ];
    return (
      <div>
        <section className="all-projects">
          {projectList.map((projet) => {
            return (
              <Link to="">
                <div className="items">
                  <img src={projet.url} alt="" />
                  <h1>{projet.name}</h1>
                </div>
              </Link>
            );
          })}
        </section>
      </div>
    );
  }
}

export default Live;
